import { useNavigate } from "react-router-dom";
import { useCommandTickets } from "../hooks/commands.hooks";
import { Ticket } from "../types/ticket.types";
import { Flex, Text } from "@chakra-ui/layout";
import TicketStatusBadge from "../components/TicketStatusBadge";
import { format } from "date-fns";

function OrdersDetailTicket({ id }: { id: number | string | undefined }) {
	const { tickets } = useCommandTickets(id);
	const navigate = useNavigate();

	if (!tickets) {
		return <>Pas de ticket pour le moment.</>;
	}
	return (
		<>
			{tickets.map((ticket: Ticket) => (
				<Flex
					key={ticket.id}
					onClick={() => navigate(`/tickets/${ticket.id}`)}
					direction="row"
					gap={2}
					my={2}
				>
					<Flex direction="row" gap={3}>
						<TicketStatusBadge id={ticket.id} />
					</Flex>
					<Flex direction="row" gap={3}>
						<Text>
							{format(ticket.createdAt, "yyyy")}-{ticket.id}
						</Text>
						<Text>{ticket.ticketLabel.label}</Text>
					</Flex>
				</Flex>
			))}
		</>
	);
}

export default OrdersDetailTicket;
